import { render } from "./NavIsland.vue?vue&type=template&id=41c8839c&scoped=true&ts=true"
import script from "./NavIsland.vue?vue&type=script&lang=ts"
export * from "./NavIsland.vue?vue&type=script&lang=ts"

import "./NavIsland.vue?vue&type=style&index=0&id=41c8839c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c8839c"]])

export default __exports__